function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m433.155 80h-353.619c-31.742 0-57.565 25.824-57.565 57.566v234.866c0 8.284 6.716 15 15 15h438.75c8.284 0 15-6.716 15-15v-234.866c0-31.742-25.825-57.566-57.566-57.566z",
  fill: "#e7f0ef"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m433.155 80h-177.155v307.432h219.721c8.284 0 15-6.716 15-15v-234.866c0-31.742-25.825-57.566-57.566-57.566z",
  fill: "#d6dbda"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m497 356.994h-482c-8.284 0-15 6.716-15 15v53.745c0 47.564 38.696 86.261 86.261 86.261h339.479c47.564 0 86.26-38.697 86.26-86.261v-53.745c0-8.284-6.716-15-15-15z",
  fill: "#0095ff"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.776,
  cy: 434.497,
  fill: "#ff0059",
  r: 14.894
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 163.776,
  cy: 434.497,
  fill: "#f7ce00",
  r: 14.894
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m497 356.994h-241v155.006h169.739c47.565 0 86.261-38.697 86.261-86.261v-53.745c0-8.284-6.716-15-15-15z",
  fill: "#006eff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m291.248 449.497h-70.496c-8.284 0-15-6.716-15-15s6.716-15 15-15h70.496c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
  fill: "#006eff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m291.248 449.497c8.284 0 15-6.716 15-15s-6.716-15-15-15h-35.248v30z",
  fill: "#003365"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m255.999 76.667c-43.884 0-79.586 35.722-79.586 79.631 0 43.908 35.702 79.631 79.586 79.631s79.587-35.722 79.587-79.631c.001-43.909-35.702-79.631-79.587-79.631z",
  fill: "#d1f05a"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m335.587 156.298c0-43.909-35.703-79.631-79.587-79.631v159.262c43.884-.001 79.587-35.723 79.587-79.631z",
  fill: "#b9dd39"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m402.55 122.89h-18.683c-3.093-12.133-7.874-23.673-14.275-34.451l13.214-13.214c1.711-1.711 2.672-4.031 2.672-6.45s-.961-4.739-2.672-6.45l-33.46-33.46c-3.562-3.563-9.338-3.562-12.899 0l-13.214 13.214c-10.778-6.401-22.316-11.181-34.451-14.275v-18.683c0-5.038-4.084-9.121-9.121-9.121h-47.321c-5.038 0-9.121 4.084-9.121 9.121v18.683c-12.135 3.093-23.673 7.874-34.451 14.275l-13.214-13.214c-3.562-3.562-9.338-3.562-12.899 0l-33.46 33.46c-1.711 1.711-2.672 4.031-2.672 6.45s.961 4.739 2.672 6.45l13.214 13.214c-6.401 10.778-11.182 22.318-14.275 34.451h-18.684c-5.038 0-9.121 4.084-9.121 9.121v47.32c0 5.038 4.084 9.121 9.121 9.121h18.683c3.093 12.133 7.874 23.673 14.275 34.451l-13.214 13.214c-1.711 1.711-2.672 4.031-2.672 6.45s.961 4.739 2.672 6.45l33.46 33.46c3.562 3.563 9.338 3.562 12.899 0l13.214-13.214c10.778 6.401 22.316 11.181 34.451 14.275v18.683c0 5.038 4.084 9.121 9.121 9.121h47.574c5.038 0 9.121-4.084 9.121-9.121v-18.689c11.972-3.073 23.426-7.85 34.201-14.265l13.211 13.211c3.562 3.562 9.338 3.562 12.899 0l33.46-33.46c1.711-1.711 2.672-4.031 2.672-6.45s-.961-4.739-2.672-6.45l-13.214-13.214c6.401-10.778 11.182-22.318 14.275-34.451h18.683c5.038 0 9.121-4.084 9.121-9.121v-47.32c.001-5.038-4.083-9.122-9.12-9.122zm-148.425 105.445c-40.154 0-72.706-32.552-72.706-72.706s32.552-72.706 72.706-72.706 72.706 32.552 72.706 72.706c0 40.155-32.552 72.706-72.706 72.706z",
  fill: "#90cc1c"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m402.55 122.89h-18.683c-3.093-12.133-7.874-23.673-14.275-34.451l13.214-13.214c1.711-1.711 2.672-4.031 2.672-6.45s-.961-4.739-2.672-6.45l-33.46-33.46c-3.562-3.563-9.338-3.562-12.899 0l-13.214 13.214c-10.778-6.401-22.316-11.181-34.451-14.275v-18.683c0-5.038-4.084-9.121-9.121-9.121h-23.661v82.947c39.288.995 70.831 33.155 70.831 72.682s-31.543 71.687-70.831 72.682v83.031h23.914c5.038 0 9.121-4.084 9.121-9.121v-18.689c11.972-3.073 23.426-7.85 34.201-14.265l13.211 13.211c3.562 3.562 9.338 3.562 12.899 0l33.46-33.46c1.711-1.711 2.672-4.031 2.672-6.45s-.961-4.739-2.672-6.45l-13.214-13.214c6.401-10.778 11.182-22.318 14.275-34.451h18.683c5.038 0 9.121-4.084 9.121-9.121v-47.32c0-5.038-4.084-9.122-9.121-9.122z",
  fill: "#6b0"
});

var Svg040Configuration = function Svg040Configuration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg040Configuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/040-configuration.8927d103.svg";
export { ForwardRef as ReactComponent };